export default "../media/bg_life_1_large.d49e9dee6db0a47165380c275e0a3f24.jpeg";